export default __webpack_public_path__ + "static/computing-b7059e3f96c4114316f2d98e7ea0fffe.png";